import { usePendingTimer, getStatusColor, getStatusBg, type PendingInfo } from "@/hooks/useChoreTimer";
import { Clock, CheckCircle, AlertTriangle, Timer } from "lucide-react";
import type { ChoreStatus } from "@/lib/chore-scheduler";

interface ChoreTimerProps {
  pending: PendingInfo | null;
  compact?: boolean;
}

const STATUS_ICONS: Record<ChoreStatus, typeof Clock> = {
  "pending": Clock,
  "due": Timer,
  "failed": AlertTriangle,
  "completed": CheckCircle,
};

export function ChoreTimer({ pending, compact }: ChoreTimerProps) {
  const state = usePendingTimer(pending);
  const Icon = STATUS_ICONS[state.status];
  const color = getStatusColor(state.status);
  const bg = getStatusBg(state.status);

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1 text-info px-1.5 py-0.5 rounded ${bg} ${color}`}>
        <Icon className="w-3 h-3" />
        {state.label}
      </span>
    );
  }

  return (
    <div className={`flex items-center gap-1.5 text-info px-2 py-1 rounded-md ${bg} ${color} font-medium`}>
      <Icon className="w-4 h-4 shrink-0" />
      <span>{state.label}</span>
    </div>
  );
}
